import { LABEL_PLAN_DAYS, LABEL_PLAN_MONTH, LABEL_PLAN_WEEK, LABEL_PLAN_YEAR } from "../../../../shared/lib/constants";
import { client } from "../apollo";
import { AUTH_TOKEN, PENDING_PROMO_CODE } from "../constants";

/**
 * getToken is a function that retrieves the authentication token from the local storage.
 *
 * @function
 * @returns {string | null} The authentication token if found in the local storage, or null if not found.
 */
export const getToken = () => localStorage.getItem(AUTH_TOKEN);

export const requiredMessage = (fieldName: string) => `${fieldName} is required.`;
export const exampleMessage = (e: string) => `i.e ${e}`;
export const validMessageForName = (fieldName: string, example?: string) => `Invalid name: ${fieldName.toLowerCase()}. ${example ? exampleMessage(example) : ""}`;

export const handleTabs = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

/**
 * handleLogout is an asynchronous function that performs the logout process.
 * It removes the authentication token from the local storage and clears the GraphQL client store.
 *
 * @function
 * @async
 * @returns {Promise<void>} A Promise that resolves when the logout process is completed.
 */
export const handleLogout = async () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(PENDING_PROMO_CODE);
  await client.clearStore();
};

/**
 * Create an array of numbers from 1 to a specified upper limit (upTo)
 * without including a specific excluded number (excludedNumber).
 *
 * @param {number} upTo - The upper limit of the range.
 * @param {number} excludedNumber - The number you want to exclude from the array.
 * @returns {number[]} An array of numbers from 1 to upTo excluding excludedNumber.
 */
export const createArrayWithoutExcludedNumber = (upTo: number, excludedNumber: number) => {
  const result = [];

  for (let i = 1; i <= upTo; i++) {
    if (i !== excludedNumber) {
      result.push(i);
    }
  }

  return result;
};

export const getPendingPromoCode = (): string | null => {
  try {
    const raw = localStorage.getItem(PENDING_PROMO_CODE);
    if (!raw) return null;
    const { code, savedAt } = JSON.parse(raw);
    const ONE_DAY_MS = 1 * 24 * 60 * 60 * 1000;
    if (typeof code === 'string' && code.trim().length > 0 && code.trim().length <= 50 && typeof savedAt === 'number') {
      if (Date.now() - savedAt < ONE_DAY_MS) {
        return code.trim();
      }
      localStorage.removeItem(PENDING_PROMO_CODE);
    }
  } catch {}
  return null;
};

export const getInterval = (value: string | undefined) => {
  switch (value) {
    case "year":
      return LABEL_PLAN_YEAR;

    case "month":
      return LABEL_PLAN_MONTH;

    case "day":
      return LABEL_PLAN_DAYS;

    case "week":
      return LABEL_PLAN_WEEK;
  };
};